export enum TempUnit {
  Celsius = 'C',
  Fahrenheit = 'F',
}
